import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { DependencyResponse } from '../../../../shared/dependenciesV2';

import { getBaseDependencyFetchQueryKey } from './queryKey';

export const getProjectDependencyQueryKey = (
  projectRevisionLocator: string,
  dependencyRevisionLocator: string,
): QueryKey => [...getBaseDependencyFetchQueryKey(dependencyRevisionLocator), 'revisions', projectRevisionLocator];

/**
 * Hook to fetch a project dependency.
 * @param projectRevisionLocator - The locator of the project revision.
 * @param dependencyRevisionLocator - The locator of the dependency revision.
 * @param shouldFetch - Whether to fetch the dependency.
 * @returns The dependency.
 */
export default function useGetProjectDependency(
  projectRevisionLocator: string,
  dependencyRevisionLocator: string,
  shouldFetch: boolean = true,
) {
  const queryKey: QueryKey = getProjectDependencyQueryKey(projectRevisionLocator, dependencyRevisionLocator);

  const queryFn = () => get<DependencyResponse>(`/api/v2/revisions/${nuc(projectRevisionLocator)}/dependencies/${nuc(dependencyRevisionLocator)}`);

  return useQuery<DependencyResponse>({
    queryKey,
    queryFn,
    enabled: shouldFetch,
  });
}
